/* eslint-disable no-undef */
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'feeder-historic-filter',
  template: require('./feeder-filter.component.html'),
})
export class FeederFilterComponent implements OnInit, OnChanges {
  front_product_front_number = 1;
  front_product_ahead_number = 1;
  front_product_front_text = '';
  front_product_ahead_text = '';
  front_product_front = false;
  front_product_ahead = false;

  front_products: any[] = [];

  formControlFrontProductFront = new FormControl();
  formControlFrontProductAhead = new FormControl();

  deliveryStart = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate(),
  };
  deliveryEnd = {
    year: new Date().getFullYear() + 1,
    month: new Date().getMonth() + 1,
    day: new Date().getDate(),
  };

  @Input() spot: boolean = false;
  @Input() product: string = '';
  @Input() loadedPrices: any[] = [];

  @Output() filteredProducts = new EventEmitter<any[]>();
  @Output() front_product = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit() {
    this.formControlFrontProductFront.valueChanges.subscribe((val) => {
      this.front_product_front = val;
      this.filterProducts();
      this.formControlEnableDisable(this.formControlFrontProductAhead, val);
    });
    this.formControlFrontProductAhead.valueChanges.subscribe((val) => {
      this.front_product_ahead = val;
      this.filterProducts();
      this.formControlEnableDisable(this.formControlFrontProductFront, val);
    });
    this.filterProducts();
  }

  formControlEnableDisable(formControl: FormControl, value: boolean) {
    if (value && formControl.enabled) {
      formControl.disable();
    } else if (!value && formControl.disabled) {
      formControl.enable();
    }
  }

  ngOnChanges() {
    this.front_product_front_text = `Front ${this.convertProduct()}`;
    this.front_product_ahead_text = `${this.convertProduct()}s ahead`;
    this.filterProducts();
  }

  restoreDefaults() {
    this.deliveryStart = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate(),
    };
    this.deliveryEnd = {
      year: new Date().getFullYear() + 1,
      month: new Date().getMonth() + 1,
      day: new Date().getDate(),
    };
    this.front_product_front_number = 1;
    this.front_product_ahead_number = 1;
    this.front_product_front = false;
    this.front_product_ahead = false;
    this.front_product_front_text = `Front ${this.convertProduct()}`;
    this.front_product_ahead_text = `${this.convertProduct()}s ahead`;
    this.filterProducts();
  }

  convertProduct() {
    switch (this.product) {
      case 'Cal':
        return 'Year';
      default:
        return this.product;
    }
  }

  filterProducts() {
    if (!this.front_product_front && !this.front_product_ahead) {
      this.front_products.length = 0;
    }
    this.front_product.emit(
      this.front_product_front || this.front_product_ahead
    );
    let products = this.loadedPrices.filter((item) => {
      if (this.front_product_front || this.front_product_ahead) {
        return item.name.includes('+') || item.name.includes('~');
      } else if (this.spot) {
        return true;
      } else {
        if (item.name.includes('+')) {
          return true;
        }
        if (item.delivery_start !== null) {
          let deliveryStart = new Date(item.delivery_start);
          //let deliveryStart = new Date(Number(date.split('-')[0]), Number(date.split('-')[1]) - 1, Number(date.split('-')[2]));
          return (
            deliveryStart >=
              new Date(
                this.deliveryStart.year,
                this.deliveryStart.month - 1,
                this.deliveryStart.day
              ) &&
            deliveryStart <=
              new Date(
                this.deliveryEnd.year,
                this.deliveryEnd.month - 1,
                this.deliveryEnd.day
              ) &&
            !item.product_code.includes(' EUR ')
          );
        }
        return !item.product_code.includes(' EUR ');
      }
    });
    this.filteredProducts.emit(products);
  }

  addFrontProduct() {
    if (
      (this.front_product_front &&
        this.front_product_front_number !== undefined &&
        this.front_product_front_number !== null &&
        this.front_product_front_number > 0 &&
        this.front_product_front_number < 100) ||
      (this.front_product_ahead &&
        this.front_product_ahead_number !== undefined &&
        this.front_product_ahead_number !== null &&
        this.front_product_ahead_number > 0 &&
        this.front_product_ahead_number < 100)
    ) {
      if (this.front_product_ahead || this.front_product_front) {
        const separator = this.front_product_ahead ? '+' : '~';
        let product_codes: any[] = [];
        this.loadedPrices.every((price) => {
          if (!price.product_code.includes(' EUR ')) {
            let product_code = price.product_code.substr(
              0,
              price.product_code.lastIndexOf(' ') + 1
            );
            if (!product_codes.includes(product_code)) {
              product_codes.push(product_code);
            }
          }
          return true;
        });
        product_codes.forEach((product_code) => {
          switch (this.product.toUpperCase()) {
            case 'CAL':
              product_code += 'Y' + separator;
              break;
            case 'MONTH':
              product_code += 'M' + separator;
              break;
            case 'QUARTER':
              product_code += 'Q' + separator;
              break;
            case 'SEASON':
              product_code += 'S' + separator;
              break;
          }
          let num = this.front_product_ahead
            ? this.front_product_ahead_number < 10
              ? '0' + this.front_product_ahead_number
              : this.front_product_ahead_number
            : this.front_product_front
              ? this.front_product_front_number < 10
                ? '0' + this.front_product_front_number
                : this.front_product_front_number
              : 0;
          product_code += num;
          let item = { product_code: product_code };
          let inProducts = false;
          this.front_products.forEach((product) => {
            if (product.product_code === product_code) {
              inProducts = true;
            }
          });
          if (!inProducts) {
            this.front_products.push(item);
          }
        });
      }
      this.filteredProducts.emit(this.front_products);
    }
  }
}
